import { render, staticRenderFns } from "./AreaSet.vue?vue&type=template&id=09e520a6&scoped=true"
import script from "./AreaSet.vue?vue&type=script&lang=js"
export * from "./AreaSet.vue?vue&type=script&lang=js"
import style0 from "./AreaSet.vue?vue&type=style&index=0&id=09e520a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e520a6",
  null
  
)

export default component.exports